import CityPageMosquiteras from "../components/CityPageMosquiteras";

export default function Page() {
  return (
    <CityPageMosquiteras
      name="Málaga"
      slug="malaga"
      cp="29001-29018"
      poblacion={597173}
      zonaGeo="Capital de la Costa del Sol"
      lat={36.7213}
      lng={-4.4214}
      zonas={[
        "Centro Histórico",
        "Carretera de Cádiz",
        "El Palo",
        "Pedregalejo",
        "Teatinos",
        "Huelin",
        "Ciudad Jardín",
      ]}
      landmarks={["Catedral", "Muelle Uno", "Castillo de Gibralfaro"]}
      municipiosLimitrofes={["Torremolinos", "Cártama", "Rincón de la Victoria"]}
      festivalLocal="Feria de Málaga (agosto)"
      contextoTipologico="Verano largo con noches cálidas, alta presencia de mosquitos en zonas costeras como El Palo y Pedregalejo, mosquito tigre activo desde junio."
      isCoreZone={true}
    />
  );
}